<template>
  <div class="game code-puzzle">
    <PinInputRoot v-model="model" :type="inputType" class="pin-input" placeholder="○" @complete="handleComplete">
      <PinInputInput v-for="(id, index) in characters" :key="id" :index="index" inputmode="numeric" />
    </PinInputRoot>
  </div>
</template>

<script lang="ts" setup>
import { PinInputInput, PinInputRoot } from 'reka-ui'

const model = defineModel<string[]>({
  default: [],
})

const props = withDefaults(
  defineProps<{
    characters?: number
    numeric?: boolean
  }>(),
  {
    characters: 4,
    numeric: true,
  },
)

const inputType = props.numeric ? 'number' : 'text'

const emit = defineEmits<{
  complete: []
}>()

const handleComplete = () => {
  emit('complete')
}
</script>
